/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Review_TracksInputs */

const en_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing review results for individual tracks.`)
};

const fr_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication des résultats de révision pour les pistes individuelles.`)
};

const de_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichung der Rezensionen einzelner Titel.`)
};

const it_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione dei risultati delle revisioni per le singole tracce.`)
};

const ru_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты рецензирования публикаций по отдельным направлениям.`)
};

const es_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de resultados de revisión de pistas individuales.`)
};

const zh_cn2_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布各曲目的评审结果。`)
};

const ja_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個々のトラックのレビュー結果を公開します。`)
};

const hi_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अलग-अलग ट्रैक के लिए समीक्षा परिणामों का प्रकाशन।`)
};

const pt_pt2_work_order_publish_status_review_tracks = /** @type {(inputs: Work_Order_Publish_Status_Review_TracksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação dos resultados das avaliações para cada faixa individual.`)
};

/**
* | output |
* | --- |
* | "Publishing review results for individual tracks." |
*
* @param {Work_Order_Publish_Status_Review_TracksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_review_tracks = /** @type {((inputs?: Work_Order_Publish_Status_Review_TracksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Review_TracksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_review_tracks(inputs)
	if (locale === "de") return de_work_order_publish_status_review_tracks(inputs)
	if (locale === "it") return it_work_order_publish_status_review_tracks(inputs)
	if (locale === "ru") return ru_work_order_publish_status_review_tracks(inputs)
	if (locale === "es") return es_work_order_publish_status_review_tracks(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_review_tracks(inputs)
	if (locale === "ja") return ja_work_order_publish_status_review_tracks(inputs)
	if (locale === "hi") return hi_work_order_publish_status_review_tracks(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_review_tracks(inputs)
	return en_work_order_publish_status_review_tracks(inputs)
});